import { applyMsgNextState, handleGetMessagesRes, preformatMessagesParams } from "helpers/chat";
import { chatTypesEnum } from "helpers/enums";
import { load, store } from "helpers/filtersStorage";
import React, { Component } from "react";
import SignalRConnection from "services/signalRConnection";
import { getChatMessages, getChatMessagesOld, STEP } from "sources/messages";
import Arrow from "./arrow";
import DateMessage from "./dateMessage";
import Filter from "./filter";
import Loader from "./loader";
import Scroll from "./scroll";
import TextMessage from "./textMessage";

const chatItemFilters = load("chat_item", {});

const chatListTypeFilter = () => {
    const typeValue = load("chats_params", {}).queryFilter?.messageTypes;
    return typeValue ? { type: { in: typeValue } } : {};
};

export default class ScrollBody extends Component {
    state = {
        shouldUpdate: true,
        skip: 0,
        endReached: false,
        items: [],
        dates: [],
        date: "",
        newMsgCount: 0,
        params: { filter: { ...chatItemFilters, ...chatListTypeFilter() } },
    };

    componentDidMount() {
        if (!this.props.readOnly) {
            const { chatId } = this.props;
            this.connection = new SignalRConnection({
                url: "/signalr/messages",
                connectionParams: chatId,
                actions: [{ name: "Send", action: (data) => this.applyMessage({ ...data, messageId: data.id }) }],
                joinActionName: "JoinChat",
                leaveActionName: "LeaveChat",
            });
        }

        this.getItems(true);
    }

    componentWillUnmount() {
        if (this.connection) {
            this.connection.disconnect();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.onlyMyMessages !== this.props.onlyMyMessages) {
            this.setState({
                shouldUpdate: true,
                skip: 0,
                endReached: false,
                items: [],
                dates: [],
                date: "",
                newMsgCount: 0,
            });
            this.getItems(true);
        }
    }

    applyMessage = (data) => {
        const prevContentHeight = this.scrollComponent.contentHeight;
        this.setState(applyMsgNextState(this.scrollComponent, this.state, data));
        this.props.updateChats({});
        if (this.scrollComponent) {
            const { prevHeight, contentHeight } = this.scrollComponent;
            this.scrollComponent.prevHeight = prevHeight + (contentHeight - prevContentHeight);
        }
    };

    updateScroll = () => {
        if (this.scrollComponent) {
            const { prevHeight, contentHeight } = this.scrollComponent;
            const scrollTo = contentHeight - prevHeight - 1;
            this.scrollComponent.updateScrollPosition(scrollTo);
        }
    };

    getItems = (first) => {
        const { chatId, info, onlyMyMessages } = this.props;
        const {
            items,
            isLoading,
            endReached,
            params: { orderBy, filter },
        } = this.state;

        if (isLoading || (!first && endReached)) {
            return;
        }

        const params = {
            queryFilter: onlyMyMessages ? { onlyMyMessages } : {},
            filter: {
                ...(!first ? preformatMessagesParams(items) : {}),
                ...(info.type === chatTypesEnum.BidChat ? filter : {}),
            },
            skip: 0,
            ...(first ? { top: STEP * 2 } : {}),
            ...(orderBy ? { orderBy } : {}),
        };
        this.setState({ shouldUpdate: false, isLoading: true });
        const req = [chatTypesEnum.DriverChat, chatTypesEnum.DocumentFlowChat, chatTypesEnum.BidChat].includes(
            this.props.info.type,
        )
            ? getChatMessages
            : getChatMessagesOld;
        return req(params, chatId).then((res) => this.handleRes(res, first));
    };

    handleRes = (res, first = null) => {
        const { items, skip } = this.state;
        this.setState({ ...handleGetMessagesRes({ res, items, first }), skip: skip + res.length });
        this.updateScroll();
        this.setState({ isLoading: false, filtersLoading: false });
    };

    renderBody = () => {
        const currentAudio = React.createRef();
        const id = parseInt(this.props.profile.id);
        const changeDate = (date) => this.setState({ date });
        const { type } = this.props.info;
        const { items, dates } = this.state;
        if (items.length === 0 && type === chatTypesEnum.DocumentFlowChat) {
            return (
                <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                    <i className="icon-uEA09-document text-gray-cc font-size-52" />
                    {this.props.readOnly ? "История и файлы не найдены" : "Документы не загружены"}
                </div>
            );
        }
        return items.map((item, i) => {
            if (item.msgType === "date") {
                return (
                    <DateMessage
                        key={item.text}
                        {...item}
                        changeDate={changeDate}
                        dates={dates}
                        chatBodyRef={this.chatBody}
                    />
                );
            }
            const props = {
                ...item,
                currentAudio,
                userId: id,
                modal: this.props.modal,
                addModal: this.props.addModal,
                index: i,
                readOnly: this.props.readOnly,
            };
            return <TextMessage key={item.id} {...props} />;
        });
    };

    filterItems = (params) => {
        store("chat_item", params.filter);
        this.setState({ params, filtersLoading: true }, () => setTimeout(() => this.getItems(true), 100));
    };

    render() {
        const { newMsgCount, shouldUpdate, endReached, isLoading, date, items, filtersLoading } = this.state;
        const isBidChat = this.props.info.type === chatTypesEnum.BidChat;
        const showOnlyMyMessages = this.props.showOnlyMyMessages === true;
        return (
            <div className="chat" style={this.props.withoutShadow ? { boxShadow: "none" } : undefined}>
                <div className="chat__body" ref={(el) => (this.chatBody = el)}>
                    <Scroll
                        ref={(el) => (this.scrollComponent = el)}
                        keepAtBottom
                        heightRelativeToParent="100%"
                        arrowPresents={!!newMsgCount}
                        clearArrow={() => this.setState({ newMsgCount: 0 })}
                        shouldUpdate={shouldUpdate}
                        getItems={this.getItems}
                    >
                        <div className="content-wrapper">
                            <Loader endReached={endReached} isLoading={isLoading} />
                            {isBidChat && ((items.length === 0 && isLoading) || filtersLoading) && (
                                <div className="loader-snippet--disable-loader">
                                    <Loader />
                                </div>
                            )}
                            {(isBidChat || showOnlyMyMessages) && (
                                <Filter
                                    filterItems={this.filterItems}
                                    params={this.state.params}
                                    profile={this.props.profile}
                                    showFileFilter={isBidChat}
                                    showOnlyMyMessages={showOnlyMyMessages}
                                    showTypeFilters={isBidChat}
                                    onlyMyMessages={this.props.onlyMyMessages}
                                    onOnlyMyMessagesChange={this.props.onOnlyMyMessagesChange}
                                />
                            )}
                            <div className="chat__current-date">{date}</div>
                            {this.renderBody()}
                            <Arrow
                                newMsgCount={newMsgCount}
                                scroll={this.scrollComponent}
                                removeArrow={() => this.setState({ newMsgCount: 0 })}
                            />
                        </div>
                    </Scroll>
                </div>
                {this.props.children}
            </div>
        );
    }
}
